import {
  useLocation, useNavigate
} from 'react-router-dom';

export default function useSafeNavigate() {
  const navigate = useNavigate();
  const location = useLocation();

  return (to, options = {}) => {
    const currentFullPath = location.pathname + location.search;
    const targetPath = typeof to === 'string' ? to : to.pathname + (to.search || '');
    
    if (targetPath !== currentFullPath) {
      navigate(to, options);
    }
  };
}
